/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RfqTransactionItem } from '../../models/rfq-transaction-item';

export interface ApiVendorRfqCompleteRfqDetailPost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
      body?: RfqTransactionItem
}

export function apiVendorRfqCompleteRfqDetailPost(http: HttpClient, rootUrl: string, params?: ApiVendorRfqCompleteRfqDetailPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RfqTransactionItem>> {
  const rb = new RequestBuilder(rootUrl, apiVendorRfqCompleteRfqDetailPost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RfqTransactionItem>;
    })
  );
}

apiVendorRfqCompleteRfqDetailPost.PATH = '/api/vendor/rfq/CompleteRfqDetail';
